import React, { useRef } from 'react'
import Helpers from '../../../helpers/shared.helper';
import Translation from "../../../services/translation.service";

const SharedAmount = ({ placeholder="", name="amount", id="amount", classname="storefront-phone-field", amount, updateAmountInput = () => {}, updateAmountField = () => {} }) => {
    const checkAmountField = (val) => {
        let validationData = Helpers.commonAmountValidateChecker(val, amount?.validation);
        let amountObj = {
            value: val,
            valid: validationData.valid,
            touched: true,
            error: validationData.errorType
        }
        updateAmountField(amountObj)
    }
    // Create a ref using useRef
    const inputRef = useRef(null);

    // Function to focus the input field
    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const validateAmountField = (event) => {
        checkAmountField(event.target.value);
    }

    return (
        <>
            <input
                ref={inputRef}
                type="text"
                className={
                    `${classname} ` +
                    (!amount.touched || (amount.touched && amount.valid)
                        ? "valid"
                        : "invalid") +
                    (amount.value ? " filled" : "")
                }
                name={name}
                id={id}
                value={amount.value}
                onChange={evnt => {
                    const inputValue = evnt.target.value;
                    const hasMultipleDecimals = (inputValue.match(/\./g) || []).length > 1;
                    const regex = /^\d*\.?\d{0,3}$/;
                    if ((regex.test(inputValue) || inputValue === '') && !hasMultipleDecimals) {                        // Convert to number and check if it's less than or equal to 2500
                        const numericValue = parseFloat(inputValue);
                        if (numericValue <= amount.validation.maxAmountValue || isNaN(numericValue)) {
                            // checkAmountField(inputValue);
                            updateAmountInput(evnt.target)
                        }
                    }
                }}
                onBlur={validateAmountField}
                placeholder={placeholder}
            />
            {amount.value ?
            <span className="amount-suffix" onClick={focusInput}><span>{amount.value ? amount.value : 0}</span>{" "}{Translation.keys["stm_general_currency"]}</span> : ""}
        </>
    );
};

export default SharedAmount;